import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listMySchools, getChinhSachLuong, putChinhSachLuong, putChinhSachCauHinh } from "./happyschoolApi";
import { getActiveSchoolId } from "./activeSchool";

// Mục "Chính sách tăng lương 2026-2027 — THPT": chỉ Owner/Admin (kế toán) xem.
// Nội dung lập từ quy tắc đang dùng để tính lương Cơ hữu ở "Chấm công theo TKB"
// (happyschool-api/src/routes/timetable.js: COHUU_*, donGiaTietVuotTheoThamNien).
// Muốn đổi mức tiền thì sửa đồng thời hằng số bên API và bảng dưới đây.
const fmt = (n) => Number(n).toLocaleString("vi-VN");

const LUONG_CO_BAN = 5700000;
const MAC_DINH_CAU_HINH = {
  bang: [1, 2, 3, 4].map((n) => ({ nam: n, label: n === 4 ? "Năm 4 trở lên" : `Năm ${n}`, thamNien: 250000 * n, clcv: 300000 })),
  ghiChu: "Mỗi năm cộng thêm 250.000 đ, cộng thêm 300.000 đ chất lượng công việc.",
}; // chỉ dùng khi chưa tải được từ máy chủ
const CHUAN_TUAN = 17;
const CHUAN_THANG = CHUAN_TUAN * 4;

const BANG_THAM_NIEN = [
  { nam: "Năm 1", dieuKien: "Đến hết 12 tháng công tác", donGia: 80000 },
  { nam: "Năm 2", dieuKien: "Trên 12 đến 24 tháng", donGia: 82000 },
  { nam: "Năm 3", dieuKien: "Trên 24 đến 36 tháng", donGia: 85000 },
  { nam: "Năm 4 trở lên", dieuKien: "Trên 36 tháng", donGia: 90000 },
];

const THANG_LIST = ["2026-09", "2026-10", "2026-11", "2026-12", "2027-01", "2027-02", "2027-03", "2027-04", "2027-05", "2027-06"];
const monthLabel = (k) => `Tháng ${Number(k.slice(5, 7))}/${k.slice(0, 4)}`;
const fmtDate = (d) => { const m = String(d || "").match(/^(\d{4})-(\d{2})-(\d{2})/); return m ? `${m[3]}/${m[2]}/${m[1]}` : String(d || ""); };

const card = { background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: 16, marginBottom: 16, boxShadow: "0 1px 3px rgba(0,0,0,.05)" };
const h3 = { margin: "0 0 10px", fontSize: 16, color: "#1f2937" };
const th = { padding: "8px 10px", border: "1px solid #d1d5db", background: "#f0fdfa", textAlign: "left", fontSize: 13 };
const td = { padding: "8px 10px", border: "1px solid #e5e7eb", fontSize: 14 };
const tdNum = { ...td, textAlign: "right", fontWeight: 600, whiteSpace: "nowrap" };

const esc = (x) => String(x == null ? "" : x).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

// In (hoặc Lưu PDF từ hộp thoại in): chính sách + danh sách giáo viên Cơ hữu của THÁNG đang chọn.
const printChinhSach = (data, mk) => {
  const w = window.open("", "_blank");
  if (!w) { alert("Trình duyệt chặn cửa sổ in. Hãy cho phép cửa sổ bật lên rồi bấm In lại."); return; }
  const rows = (data && data.rows) || [];
  const cfg = (data && data.cauHinh) || MAC_DINH_CAU_HINH;
  const tr = rows.map((r, i) => `<tr><td class="c">${i + 1}</td><td><b>${esc(r.hoten)}</b></td><td>${esc(r.bomon)}</td><td>${esc(r.khongCongThuc ? `${r.loai} · ${r.khongCongThuc}` : r.loai)}</td><td class="c">${esc(fmtDate(r.workStartDate))}</td><td>${r.apDungThamNien ? `Năm ${r.namThu}${r.soThangCongTac ? ` (${r.soThangCongTac} tháng)` : ""}` : "Không áp dụng"}</td><td class="n">${r.donGiaTietVuot == null ? "—" : fmt(r.donGiaTietVuot)}</td><td class="n">${r.luongThamNien == null ? "—" : fmt(r.luongThamNien)}</td><td>${esc(r.ghiChu || "")}</td></tr>`).join("");
  const tn = BANG_THAM_NIEN.map((r) => `<tr><td><b>${esc(r.nam)}</b></td><td>${esc(r.dieuKien)}</td><td class="n">${fmt(r.donGia)} đ</td></tr>`).join("");
  const now = new Date();
  const ngayIn = `${String(now.getDate()).padStart(2, "0")}/${String(now.getMonth() + 1).padStart(2, "0")}/${now.getFullYear()}`;
  w.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>Chính sách tăng lương 2026-2027 - THPT</title>
<style>
  body{font-family:Arial,Helvetica,sans-serif;font-size:12px;color:#111;margin:18px}
  h1{font-size:18px;text-align:center;margin:0 0 4px} h2{font-size:14px;margin:16px 0 6px}
  .sub{text-align:center;color:#444;margin:0 0 10px} ul{margin:4px 0 4px 18px;padding:0;line-height:1.6}
  table{border-collapse:collapse;width:100%;margin-top:4px} th,td{border:1px solid #444;padding:4px 6px;vertical-align:top}
  th{background:#e5f5f3;text-align:left} td.n{text-align:right;white-space:nowrap} td.c{text-align:center}
  .box{border:1px dashed #555;padding:6px 8px;margin:4px 0}
  .ky{display:flex;justify-content:space-between;margin-top:28px;text-align:center} .ky div{width:45%}
  @media print{ body{margin:8mm} tr{page-break-inside:avoid} thead{display:table-header-group} }
</style></head><body>
<h1>CHÍNH SÁCH TĂNG LƯƠNG NĂM HỌC 2026–2027 — THPT</h1>
<p class="sub">Giáo viên Cơ hữu · Áp dụng từ tháng 9/2026 · Danh sách tại ${esc(monthLabel(mk))}</p>
<h2>1. Công thức tiền lương hằng tháng</h2>
<div class="box"><b>Tiền</b> = Lương cơ bản + Lương thâm niên + Chất lượng công việc + Đơn giá tiết vượt × (Tổng số tiết − ${CHUAN_THANG}) + Hỗ trợ khác (nếu có)</div>
<ul>
  <li>Lương cơ bản: <b>${fmt(LUONG_CO_BAN)}</b> đ/tháng.</li>
  <li>Tiết chuẩn: <b>${CHUAN_THANG}</b> tiết/tháng (${CHUAN_TUAN} tiết/tuần × 4 tuần). Chỉ trả thêm khi dạy vượt chuẩn.</li>
  <li>Tổng số tiết = tiết Chính khoá + Tăng cường + Chủ nhiệm (lớp 1: 2 tiết/tuần, lớp 2: 4 tiết/tuần) + coi thi khảo sát.</li>
  <li>Hỗ trợ khác: điện thoại GVCN 200.000 đ/lớp chủ nhiệm; dạy môn thi tốt nghiệp lớp 12: 100.000 đ/lớp.</li>
</ul>
<h2>2. Đơn giá tiết vượt theo năm công tác</h2>
<table><thead><tr><th>Năm công tác</th><th>Thời gian công tác</th><th style="text-align:right">Đơn giá / tiết vượt</th></tr></thead><tbody>${tn}</tbody></table>
<h2>3. Lương thâm niên + Chất lượng công việc</h2>
<p><i>Chú thích: ${esc(cfg.ghiChu)}</i></p>
<table><thead><tr><th>Năm công tác</th><th style="text-align:right">Thâm niên (đ/tháng)</th><th style="text-align:right">Chất lượng công việc (đ/tháng)</th><th style="text-align:right">Cộng (đ/tháng)</th></tr></thead><tbody>${cfg.bang.map((m) => `<tr><td><b>${esc(m.label)}</b></td><td class="n">${fmt(m.thamNien)}</td><td class="n">${fmt(m.clcv)}</td><td class="n"><b>${fmt(Number(m.thamNien) + Number(m.clcv))}</b></td></tr>`).join("")}</tbody></table>
<p>Mỗi giáo viên có thể có mức riêng và được giữ nguyên cho các tháng sau cho đến khi đặt lại.</p>
<h2>4. Danh sách giáo viên Cơ hữu — ${esc(monthLabel(mk))} (${rows.length} người)</h2>
<table><thead><tr><th>STT</th><th>Họ và tên</th><th>Bộ môn</th><th>Loại</th><th>Ngày vào làm</th><th>Năm công tác</th><th style="text-align:right">Tính theo tiết vượt (đ/tiết)</th><th style="text-align:right">Lương thâm niên + Chất lượng công việc (đ/tháng)</th><th>Chú thích</th></tr></thead><tbody>${tr}</tbody></table>
<p style="margin-top:6px;color:#444">FullTime và nhóm định mức riêng không tính theo công thức này (hiện “—”). Giáo viên Thỉnh giảng không thuộc chính sách này.</p>
<div class="ky"><div>Người lập biểu<br><i>(Ký, ghi rõ họ tên)</i></div><div>Ngày ${esc(ngayIn)}<br><b>Hiệu trưởng</b><br><i>(Ký, đóng dấu)</i></div></div>
<script>window.onload=function(){setTimeout(function(){window.print();},300);};<\/script>
</body></html>`);
  w.document.close();
};

const HappySchoolChinhSachLuong = () => {
  const schoolId = getActiveSchoolId();
  const [allowed, setAllowed] = useState(null); // null = đang kiểm tra
  const [mk, setMk] = useState(() => { const k = new Date().toISOString().slice(0, 7); return THANG_LIST.includes(k) ? k : THANG_LIST[0]; });
  const [data, setData] = useState(null);
  const [loadingList, setLoadingList] = useState(false);
  const [listErr, setListErr] = useState("");
  const [bangDraft, setBangDraft] = useState([]); // bảng mục 3 đang sửa
  const [ghiChuDraft, setGhiChuDraft] = useState("");
  const [cfgMsg, setCfgMsg] = useState("");
  const [saving, setSaving] = useState(""); // staffId đang lưu
  const [saveErr, setSaveErr] = useState("");

  useEffect(() => {
    if (!schoolId) { setAllowed(false); return; }
    listMySchools()
      .then((list) => {
        const s = (list || []).find((x) => x.id === schoolId);
        const roles = s ? (Array.isArray(s.roles) && s.roles.length ? s.roles : s.role ? [s.role] : []) : [];
        setAllowed(roles.some((r) => r === "owner" || r === "admin"));
      })
      .catch(() => setAllowed(false));
  }, [schoolId]);

  const reload = () => getChinhSachLuong(schoolId, mk).then(setData).catch((e) => setListErr(e.message || "Lỗi tải danh sách."));
  useEffect(() => {
    if (!allowed || !schoolId) return;
    setLoadingList(true); setListErr("");
    getChinhSachLuong(schoolId, mk).then(setData).catch((e) => { setData(null); setListErr(e.message || "Lỗi tải danh sách."); }).finally(() => setLoadingList(false));
  }, [allowed, schoolId, mk]);

  const cfg = (data && data.cauHinh) || MAC_DINH_CAU_HINH;
  // Nạp lại bảng đang sửa mỗi khi cấu hình từ máy chủ đổi.
  const cfgKey = JSON.stringify(cfg);
  useEffect(() => { setBangDraft(cfg.bang.map((r) => ({ ...r }))); setGhiChuDraft(cfg.ghiChu); }, [cfgKey]); // eslint-disable-line
  const suaDong = (i, k, v) => setBangDraft((b) => b.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  const luuCauHinh = async () => {
    setCfgMsg("");
    const bang = bangDraft.map((r) => ({ nam: Number(r.nam), label: String(r.label || "").trim(), thamNien: Number(r.thamNien), clcv: Number(r.clcv) }));
    if (!bang.length) { setCfgMsg("Bảng cần ít nhất 1 dòng."); return; }
    if (bang.some((r) => !Number.isInteger(r.nam) || r.nam < 1 || !Number.isFinite(r.thamNien) || !Number.isFinite(r.clcv) || r.thamNien < 0 || r.clcv < 0)) { setCfgMsg("Năm thứ phải là số nguyên từ 1, số tiền không âm."); return; }
    if (new Set(bang.map((r) => r.nam)).size !== bang.length) { setCfgMsg("Có 2 dòng trùng “năm thứ”."); return; }
    try { await putChinhSachCauHinh(schoolId, { bang, ghiChu: ghiChuDraft }); await reload(); setCfgMsg("Đã lưu."); }
    catch (e) { setCfgMsg(e.message || "Không lưu được."); }
  };

  // Lưu 1 ô sửa trực tiếp (năm công tác hoặc lương thâm niên + chất lượng công việc) rồi tải lại danh sách.
  const luu = async (staffId, patch) => {
    setSaving(staffId); setSaveErr("");
    try { await putChinhSachLuong(schoolId, staffId, { monthKey: mk, ...patch }); await reload(); }
    catch (e) { setSaveErr(e.message || "Không lưu được."); }
    finally { setSaving(""); }
  };

  if (allowed === null) return <p style={{ color: "#6b7280", padding: 24 }}>Đang tải...</p>;
  if (!allowed) return <p style={{ color: "#b91c1c", padding: 24 }}>Mục này chỉ dành cho Admin/Kế toán.</p>;

  return (
    <div style={{ padding: "8px 12px", maxWidth: 900, margin: "0 auto" }}>
      <div style={{ marginBottom: 8 }}><Link to="/happyschool" style={{ fontSize: 13 }}>← Trang chủ HappySchool</Link></div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12, flexWrap: "wrap" }}>
        <h2 style={{ margin: "0 0 4px", fontSize: 22 }}>📈 Chính sách tăng lương 2026–2027 — THPT</h2>
        <button type="button" onClick={() => printChinhSach(data, mk)} disabled={!data || loadingList}
          style={{ padding: "8px 14px", borderRadius: 8, border: "1px solid #0ea5a3", background: data && !loadingList ? "#0ea5a3" : "#9ca3af", color: "#fff", fontWeight: 600, fontSize: 14, cursor: data && !loadingList ? "pointer" : "not-allowed" }}>
          🖨️ In
        </button>
      </div>
      <p style={{ margin: "0 0 16px", color: "#6b7280", fontSize: 13 }}>
        Áp dụng cho giáo viên Cơ hữu khối THPT, từ tháng 9/2026 (năm học 2026–2027). Chỉ Admin/Kế toán xem được.
      </p>

      <div style={card}>
        <h3 style={h3}>1. Công thức tiền lương hằng tháng</h3>
        <div style={{ background: "#f8fafc", border: "1px dashed #94a3b8", borderRadius: 8, padding: "10px 12px", fontSize: 14, lineHeight: 1.7 }}>
          <b>Tiền</b> = Lương cơ bản + Lương thâm niên + Chất lượng công việc + Đơn giá tiết vượt × (Tổng số tiết − {CHUAN_THANG}) + (Hỗ trợ khác nếu có)
        </div>
        <ul style={{ margin: "10px 0 0", paddingLeft: 20, fontSize: 14, lineHeight: 1.7 }}>
          <li><b>Lương cơ bản:</b> {fmt(LUONG_CO_BAN)} đ/tháng.</li>
          <li><b>Tiết chuẩn:</b> {CHUAN_THANG} tiết/tháng ({CHUAN_TUAN} tiết/tuần × 4 tuần). Chỉ trả thêm khi dạy vượt chuẩn.</li>
          <li><b>Tổng số tiết</b> = tiết Chính khoá + tiết Tăng cường + tiết Chủ nhiệm (lớp thứ 1: 2 tiết/tuần, lớp thứ 2: 4 tiết/tuần) + tiết coi thi khảo sát.</li>
          <li><b>Hỗ trợ khác:</b> điện thoại GVCN 200.000 đ/lớp chủ nhiệm; dạy môn thi tốt nghiệp lớp 12: 100.000 đ/lớp.</li>
        </ul>
      </div>

      <div style={card}>
        <h3 style={h3}>2. Đơn giá tiết vượt theo năm công tác</h3>
        <p style={{ margin: "0 0 8px", fontSize: 13, color: "#4b5563" }}>
          Tính tự động từ “Ngày bắt đầu làm việc” trong hồ sơ, đếm đến hết tháng tính lương (tính cả tháng đầu). Chỉ áp dụng cho hồ sơ có khai thâm niên; hồ sơ khác hoặc đánh dấu “Không áp dụng thâm niên” luôn 80.000 đ.
        </p>
        <table style={{ borderCollapse: "collapse", width: "100%" }}>
          <thead><tr><th style={th}>Năm công tác</th><th style={th}>Thời gian công tác</th><th style={{ ...th, textAlign: "right" }}>Đơn giá / tiết vượt</th></tr></thead>
          <tbody>
            {BANG_THAM_NIEN.map((r) => (
              <tr key={r.nam}><td style={td}><b>{r.nam}</b></td><td style={td}>{r.dieuKien}</td><td style={tdNum}>{fmt(r.donGia)} đ</td></tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={card}>
        <h3 style={h3}>3. Lương thâm niên + Chất lượng công việc</h3>
        <label style={{ fontSize: 13, display: "block", marginBottom: 8 }}>✏️ Chú thích<br />
          <input type="text" value={ghiChuDraft} onChange={(e) => setGhiChuDraft(e.target.value)} maxLength={300}
            style={{ width: "100%", boxSizing: "border-box", padding: "6px 8px", borderRadius: 6, border: "1px solid #cbd5e1", fontSize: 14, fontStyle: "italic" }} />
        </label>
        <div style={{ overflowX: "auto" }}>
          <table style={{ borderCollapse: "collapse", width: "100%", minWidth: 640 }}>
            <thead><tr>
              <th style={th}>Năm thứ</th><th style={th}>Tên hiển thị</th>
              <th style={{ ...th, textAlign: "right" }}>Thâm niên (đ/tháng)</th><th style={{ ...th, textAlign: "right" }}>Chất lượng công việc (đ/tháng)</th>
              <th style={{ ...th, textAlign: "right" }}>Cộng (đ/tháng)</th><th style={th}></th>
            </tr></thead>
            <tbody>
              {bangDraft.map((m, i) => {
                const inp = { padding: "4px 6px", borderRadius: 6, border: "1px solid #cbd5e1", fontSize: 13 };
                return (
                  <tr key={i}>
                    <td style={td}><input type="number" min="1" step="1" value={m.nam} onChange={(e) => suaDong(i, "nam", e.target.value)} style={{ ...inp, width: 60 }} /></td>
                    <td style={td}><input type="text" value={m.label} maxLength={40} onChange={(e) => suaDong(i, "label", e.target.value)} style={{ ...inp, width: 150 }} /></td>
                    <td style={tdNum}><input type="number" min="0" step="10000" value={m.thamNien} onChange={(e) => suaDong(i, "thamNien", e.target.value)} style={{ ...inp, width: 120, textAlign: "right" }} /></td>
                    <td style={tdNum}><input type="number" min="0" step="10000" value={m.clcv} onChange={(e) => suaDong(i, "clcv", e.target.value)} style={{ ...inp, width: 120, textAlign: "right" }} /></td>
                    <td style={{ ...tdNum, background: "#f0fdfa" }}>{fmt((Number(m.thamNien) || 0) + (Number(m.clcv) || 0))}</td>
                    <td style={td}><button type="button" disabled={bangDraft.length <= 1} onClick={() => setBangDraft((b) => b.filter((_, j) => j !== i))}
                      style={{ padding: "3px 8px", borderRadius: 6, border: "1px solid #fca5a5", background: "#fff", color: "#b91c1c", fontSize: 12, cursor: "pointer" }}>Xoá dòng</button></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginTop: 8 }}>
          <button type="button" onClick={() => setBangDraft((b) => { const n = b.reduce((mx, r) => Math.max(mx, Number(r.nam) || 0), 0) + 1; return [...b, { nam: n, label: `Năm ${n}`, thamNien: 0, clcv: 0 }]; })}
            style={{ padding: "6px 12px", borderRadius: 8, border: "1px solid #94a3b8", background: "#fff", fontSize: 13, cursor: "pointer" }}>+ Thêm dòng</button>
          <button type="button" onClick={luuCauHinh} style={{ padding: "6px 16px", borderRadius: 8, border: "1px solid #0ea5a3", background: "#0ea5a3", color: "#fff", fontWeight: 600, fontSize: 14, cursor: "pointer" }}>Lưu bảng</button>
          {cfgMsg ? <span style={{ fontSize: 13, color: cfgMsg === "Đã lưu." ? "#0f766e" : "#b91c1c" }}>{cfgMsg}</span> : null}
        </div>
        <p style={{ margin: "8px 0 0", fontSize: 13, color: "#4b5563" }}>Mỗi giáo viên có thể có mức riêng; đặt một lần ở tháng nào thì các tháng sau tự giữ nguyên cho đến khi đặt lại.</p>
      </div>

      <div style={card}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 10 }}>
          <h3 style={{ ...h3, margin: 0 }}>4. Danh sách giáo viên Cơ hữu</h3>
          <select value={mk} onChange={(e) => setMk(e.target.value)} style={{ padding: "6px 10px", borderRadius: 6, border: "1px solid #cbd5e1", fontSize: 14, fontWeight: 600 }}>
            {THANG_LIST.map((k) => <option key={k} value={k}>{monthLabel(k)}</option>)}
          </select>
          {data && <span style={{ fontSize: 13, color: "#6b7280" }}>{data.rows.length} giáo viên Cơ hữu đang làm</span>}
        </div>
        <p style={{ margin: "0 0 8px", fontSize: 13, color: "#4b5563" }}>
          “Tính theo tiết vượt” là đơn giá mỗi tiết vượt chuẩn {CHUAN_THANG} tiết/tháng của từng người, theo năm công tác tại tháng đang chọn. “Lương thâm niên + Chất lượng công việc” là mức đang áp dụng cho tháng đó (đặt riêng, hoặc kế thừa tháng trước, hoặc mặc định). FullTime và nhóm định mức riêng không tính theo công thức này nên hiện “—”. Giáo viên Thỉnh giảng không thuộc chính sách này nên không liệt kê.
        </p>
        <p style={{ margin: "0 0 8px", fontSize: 12, color: "#0f766e" }}>
          ✏️ Sửa trực tiếp: đổi “Năm công tác” bằng ô chọn; gõ số mới vào ô “Lương thâm niên + Chất lượng công việc” rồi Enter (áp dụng cho {monthLabel(mk)} và các tháng sau cho đến khi đặt lại). Mức tiết vượt tự đổi theo năm công tác.
        </p>
        {saveErr ? <p style={{ color: "#b91c1c", fontSize: 13 }}>{saveErr}</p> : null}
        {loadingList ? <p style={{ color: "#6b7280" }}>Đang tải danh sách...</p> : listErr ? <p style={{ color: "#b91c1c" }}>{listErr}</p> : data && (
          <div style={{ overflowX: "auto" }}>
            <table style={{ borderCollapse: "collapse", width: "100%", minWidth: 760 }}>
              <thead><tr>
                <th style={th}>STT</th><th style={th}>Họ và tên</th><th style={th}>Bộ môn</th><th style={th}>Loại</th>
                <th style={th}>Ngày vào làm</th><th style={th}>Năm công tác</th>
                <th style={{ ...th, textAlign: "right" }}>Tính theo tiết vượt (đ/tiết)</th>
                <th style={{ ...th, textAlign: "right" }}>Lương thâm niên + Chất lượng công việc (đ/tháng)</th>
                <th style={th}>Chú thích</th>
                <th style={th}></th>
              </tr></thead>
              <tbody>
                {data.rows.map((r, i) => (
                  <tr key={r.staffId}>
                    <td style={td}>{i + 1}</td>
                    <td style={{ ...td, fontWeight: 600 }}>{r.hoten}</td>
                    <td style={td}>{r.bomon}</td>
                    <td style={td}>{r.khongCongThuc ? `${r.loai} · ${r.khongCongThuc}` : r.loai}</td>
                    <td style={td}>{fmtDate(r.workStartDate)}</td>
                    <td style={td}>
                      <select value={r.apDungThamNien ? String(r.namThu) : "0"} disabled={saving === r.staffId}
                        onChange={(e) => luu(r.staffId, { nam: Number(e.target.value) })}
                        style={{ padding: "4px 6px", borderRadius: 6, border: "1px solid #cbd5e1", fontSize: 13 }}>
                        <option value="0">Không áp dụng</option>
                        <option value="1">Năm 1</option><option value="2">Năm 2</option><option value="3">Năm 3</option><option value="4">Năm 4 trở lên</option>
                      </select>
                      {r.apDungThamNien && r.soThangCongTac ? <span style={{ marginLeft: 6, fontSize: 12, color: "#6b7280" }}>({r.soThangCongTac} tháng)</span> : null}
                      {r.ghiDeNam != null ? <span title="Đã sửa tay trên trang này" style={{ marginLeft: 4, fontSize: 12 }}>✏️</span> : null}
                    </td>
                    <td style={tdNum}>{r.donGiaTietVuot == null ? "—" : fmt(r.donGiaTietVuot)}</td>
                    <td style={tdNum} title={r.luongThamNienNguon}>
                      {r.luongThamNien == null ? "—" : (
                        <input key={`${r.staffId}-${mk}-${r.luongThamNien}`} type="number" min="0" step="10000" defaultValue={r.luongThamNien} disabled={saving === r.staffId}
                          onBlur={(e) => { const v = e.target.value; if (v !== "" && Number(v) !== Number(r.luongThamNien)) luu(r.staffId, { luongThamNien: Number(v) }); }}
                          onKeyDown={(e) => { if (e.key === "Enter") e.target.blur(); }}
                          style={{ width: 110, padding: "4px 6px", borderRadius: 6, border: "1px solid #cbd5e1", fontSize: 13, textAlign: "right" }} />
                      )}
                    </td>
                    <td style={td}>
                      <input key={`${r.staffId}-gc-${mk}-${r.ghiChu}`} type="text" maxLength={300} defaultValue={r.ghiChu || ""} disabled={saving === r.staffId} placeholder="Ghi chú..."
                        onBlur={(e) => { if (e.target.value.trim() !== (r.ghiChu || "").trim()) luu(r.staffId, { ghiChu: e.target.value }); }}
                        onKeyDown={(e) => { if (e.key === "Enter") e.target.blur(); }}
                        style={{ width: 200, padding: "4px 6px", borderRadius: 6, border: "1px solid #cbd5e1", fontSize: 13 }} />
                    </td>
                    <td style={td}>
                      <button type="button" disabled={saving === r.staffId} onClick={() => { if (window.confirm(`Bỏ ${r.hoten} khỏi danh sách THPT?`)) luu(r.staffId, { an: true, lyDo: "Không thuộc THPT (GV nghề/khác)" }); }}
                        style={{ padding: "3px 8px", borderRadius: 6, border: "1px solid #fca5a5", background: "#fff", color: "#b91c1c", fontSize: 12, cursor: "pointer" }}>Bỏ</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {data && data.anRows && data.anRows.length > 0 && (
          <div style={{ marginTop: 12, padding: "8px 10px", background: "#f8fafc", border: "1px dashed #94a3b8", borderRadius: 8, fontSize: 13 }}>
            <b>Đã bỏ khỏi danh sách ({data.anRows.length}):</b>{" "}
            {data.anRows.map((a) => (
              <span key={a.staffId} style={{ display: "inline-block", margin: "2px 8px 2px 0" }}>
                {a.hoten}{" "}
                <button type="button" disabled={saving === a.staffId} onClick={() => luu(a.staffId, { an: false })}
                  style={{ padding: "1px 6px", borderRadius: 6, border: "1px solid #5eead4", background: "#fff", color: "#0f766e", fontSize: 12, cursor: "pointer" }}>Thêm lại</button>
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default HappySchoolChinhSachLuong;
